/**
 * @generated SignedSource<<e32c44bba722417e8e1a424bbed618b0>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: agg
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  /** AppStorageEntityValue */
  AppStorageEntityValue: {
    input: any;
    output: any;
  };
  /** AppStoredEntityFieldValue */
  AppStoredCustomEntityFieldValue: {
    input: any;
    output: any;
  };
  /** AppStoredEntityFieldValue */
  AppStoredEntityFieldValue: {
    input: any;
    output: any;
  };
  /** A scalar that can represent arbitrary-precision signed decimal numbers based on the JVMs [BigDecimal](https://docs.oracle.com/javase/8/docs/api/java/math/BigDecimal.html) */
  BigDecimal: {
    input: any;
    output: any;
  };
  /** Supported colors in the Palette */
  CardPaletteColor: {
    input: any;
    output: any;
  };
  /** CardTypeHierarchyLevelType */
  CardTypeHierarchyLevelType: {
    input: any;
    output: any;
  };
  /** A date scalar that accepts string values that are in yyyy-mm-dd format */
  Date: {
    input: any;
    output: any;
  };
  /** A scalar representing a specific point in time. */
  DateTime: {
    input: Date;
    output: Date;
  };
  /**
   * A scalar that enables us to spike [3D](https://relay.dev/docs/glossary/#3d) aka data-driven dependencies
   * This scalar is a requirement for using @match and @module directive supported by Relay GraphQL client
   * Please talk to #uip-app-framework before using this.
   * The definition of the scalar is yet to be decided based on spike insights.
   * To learn about current state see https://go.atlassian.com/JSDependency
   * DO NOT USE: Platform teams are iterating on the final shape of data returned
   */
  JSDependency: {
    input: any;
    output: any;
  };
  /**
   * The `JSON` scalar type represents JSON values as specified
   * by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).
   *
   * Note to schema designers - use this scalar with caution as the resultant data becomes untyped
   * from a consumers point of view.  There are legitimate use cases for this scalar type
   * but it SHOULD not be a common scalar.
   */
  JSON: {
    input: {
      [key: string]: any;
    };
    output: {
      [key: string]: any;
    };
  };
  /**
   * Atlassian Document Format (ADF) - A JSON format for rich text content.
   * @see https://developer.atlassian.com/cloud/jira/platform/apis/document/structure/
   *
   * TODO: Implement custom scalar with ADF validation
   */
  KitsuneADF: {
    input: any;
    output: any;
  };
  /** A scalar that is a 64-bit signed Java primitive data type. Its range is -2^63 to 2^63 – 1 */
  Long: {
    input: number;
    output: number;
  };
  /** MercuryJSONString */
  MercuryJSONString: {
    input: any;
    output: any;
  };
  /** SoftwareBoardFeatureKey */
  SoftwareBoardFeatureKey: {
    input: any;
    output: any;
  };
  /** SoftwareBoardPermission */
  SoftwareBoardPermission: {
    input: any;
    output: any;
  };
  /** SprintScopeChangeEventType */
  SprintScopeChangeEventType: {
    input: any;
    output: any;
  };
  /** Position for a card - can be a numeric position or relative position ('top' or 'bottom') */
  TrelloCardPosition: {
    input: any;
    output: any;
  };
  /**
   * A unique short string that can be used to fetch a board, card, etc. It's
   * usually used as a part of the entity URL. In some cases can be used as
   * as the ID.
   */
  TrelloShortLink: {
    input: any;
    output: any;
  };
  /** An URL scalar that accepts string values like [https://www.w3.org/Addressing/URL/url-spec.txt]( https://www.w3.org/Addressing/URL/url-spec.txt) */
  URL: {
    input: any;
    output: any;
  };
  /** UUID */
  UUID: {
    input: any;
    output: any;
  };
  /** Upload */
  Upload: {
    input: any;
    output: any;
  };
}
export enum AccessType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}
export interface RequestPageAccessInput {
  accessType: AccessType;
  pageId: Scalars["String"]["input"];
}
export type AskToEditBoxRequestPageAccessMutation_requestPageAccess_RequestPageAccessPayload =
  {
    __typename?: "RequestPageAccessPayload";
    displayName: string;
  };
export type AskToEditBoxRequestPageAccessMutation_Mutation = {
  __typename?: "Mutation";
  requestPageAccess: AskToEditBoxRequestPageAccessMutation_requestPageAccess_RequestPageAccessPayload | null;
};
export type AskToEditBoxRequestPageAccessMutationVariables = Exact<{
  requestPageAccessInput: RequestPageAccessInput;
}>;
export type AskToEditBoxRequestPageAccessMutation =
  AskToEditBoxRequestPageAccessMutation_Mutation;
